import { BlinkHighchartConfig } from '../highcharts/blink-highchart-config';
class BlinkInsightchartConfig extends BlinkHighchartConfig {
    constructor(chartModel, dataModel, config, env) {
        super(chartModel, dataModel, {
            containerDimensions: config.containerDimensions,
            shouldShowXAxisLabels: config.shouldShowXAxisLabels,
            shouldShowYAxisLabels: config.shouldShowYAxisLabels,
            disableTransformations: config.disableTransformations,
            disableColorRotation: config.disableColorRotation,
            shouldShowDataLabels: config.shouldShowDataLabels,
            isDataSourceDefault: config.isDataSourceDefault,
            hideAxisIcon: config.hideAxisIcon,
            shouldShowXAxisName: config.shouldShowXAxisName,
            shouldShowYAxisName: config.shouldShowYAxisName,
        }, env);
        return this;
    }
}
export { BlinkInsightchartConfig };
//# sourceMappingURL=blink-insightchart-config.js.map